import type { IToolbar, TDebugFeature } from '../models';

import type { TFeatureName, EFeatureValue } from '@/features/feature-flags/featureFlagsModels';
import { ELocalStorageKeys } from '@/features/store/ELocalStorageKeys';
import { useLocalStorage } from '@vueuse/core';
import { defaultState } from './config';
import { isProdBuildMode } from '#shared/helpers/buildMode';

const TOOLBAR_STORAGE_KEY = ELocalStorageKeys.MM__TOOLBAR_STORAGE_KEY;

class ToolbarStorageClass {
  private readonly toolbarStorage?: Ref<IToolbar>;

  constructor() {
    if (isProdBuildMode()) return;

    this.toolbarStorage = useLocalStorage(
      TOOLBAR_STORAGE_KEY,
      { ...defaultState() },
      { mergeDefaults: true }
    );
  }

  public getStorageToolbarField<T extends keyof IToolbar>(field: string): IToolbar[T] | undefined {
    // @ts-ignore
    return this.toolbarStorage?.value[field];
  }

  public getDebugValue(field: TDebugFeature): boolean {
    // @ts-ignore
    return this.toolbarStorage?.value.debug[field];
  }

  public setFeatureFlag({ name, value }: { name: TFeatureName; value: EFeatureValue }): void {
    if (!this.toolbarStorage) return;

    this.toolbarStorage.value.featureFlags[name] = value;
  }

  public setDebugFlag({ name, value }: { name: TDebugFeature; value: boolean }): void {
    if (!this.toolbarStorage) return;

    this.toolbarStorage.value.debug[name] = value;
  }

  public setRestEnv(restEnv: IToolbar['restEnv']): void {
    if (!this.toolbarStorage) return;

    this.toolbarStorage.value.restEnv = restEnv;
  }
}

export const ToolbarStorage = new ToolbarStorageClass();
